import { SET_REPORT_MODAL_OPEN_STATUS } from '../actionTypes';
import { actions } from '../reducer';

export default (value) => actions[SET_REPORT_MODAL_OPEN_STATUS](value);
